export default "__VITE_ASSET__BpInbFjA__"